export default [
	{ code: 100, label: 'Load/Unload', main: false, onsite: false },
	{ code: 101, label: 'Fabrication', main: false, onsite: false },
	{ code: 102, label: 'Travel', main: false, onsite: false },
	{
		code: 103,
		label: 'Onsite',
		main: true,
		onsite: true
	},
	{
		code: 108,
		label: 'Rope Access',
		main: false,
		onsite: true
	},
	{
		code: 109,
		label: 'Wading',
		main: false,
		onsite: true
	},
	{
		code: 110,
		label: 'Diving',
		main: false,
		onsite: true
	},
	{
		code: 111,
		label: 'Tending NY Project EDC',
		main: false,
		onsite: true
	},
	{ code: 112, label: 'Standby', main: false, onsite: true },
	{ code: 120, label: 'Project Management', main: false, onsite: false },
	{ code: 121, label: 'Correspondence', main: false, onsite: false },
	{ code: 122, label: 'Planning', main: false, onsite: false },
	{ code: 123, label: 'Submittals', main: false, onsite: false },
	{ code: 124, label: 'Report', main: false, onsite: false },
	{ code: 125, label: 'Analysis', main: false, onsite: false },
	{ code: 126, label: 'Design', main: false, onsite: false },
	{ code: 127, label: 'Drawings', main: false, onsite: false },
	{ code: 128, label: 'Specifications', main: false, onsite: false },
	{ code: 129, label: 'Cost Estimating', main: false, onsite: false },
	{ code: 130, label: 'Hat Repair', main: false, onsite: false },
	{ code: 131, label: 'Imaging', main: false, onsite: true },
	{ code: 132, label: 'Process Imaging', main: false, onsite: false },
	{ code: 133, label: 'Party Chief NYDOT', main: false, onsite: true },
	{
		code: 134,
		label: 'Instrument Person NYDOT',
		main: false,
		onsite: true
	},
	{ code: 135, label: 'Rod Person NYDOT', main: false, onsite: true },
	{ code: 200, label: 'General/Admin', main: false, onsite: false },
	{ code: 201, label: 'Fabrication', main: false, onsite: false },
	{ code: 202, label: 'Maintenance', main: false, onsite: false },
	{ code: 203, label: 'Safety', main: false, onsite: false },
	{ code: 204, label: 'Meeting', main: false, onsite: false },
	{ code: 205, label: 'Business Development', main: false, onsite: false },
	{ code: 206, label: 'Proposal', main: false, onsite: false },
	{ code: 207, label: 'Travel', main: false, onsite: false },
	{ code: 208, label: 'Seminar/Conference', main: false, onsite: false },
	{ code: 209, label: 'Training', main: false, onsite: false },
	{ code: 210, label: 'Human Resources', main: false, onsite: false },
	{ code: 211, label: 'Invoicing/Accounting', main: false, onsite: false },
	{ code: 212, label: 'Corporate Management', main: false, onsite: false },
	{
		code: 213,
		label: 'Information Technology',
		main: false,
		onsite: false
	},
	{ code: 220, label: 'Holiday', main: false, onsite: false },
	{ code: 221, label: 'Vacation', main: false, onsite: false },
	{ code: 222, label: 'Sick', main: false, onsite: false },
	{ code: 223, label: 'Jury Duty', main: false, onsite: false },
	{ code: 224, label: 'Bereavement', main: false, onsite: false },
	{
		code: 310,
		label: "Diving Greater than 99'",
		main: false,
		onsite: true
	},
	{ code: 403, label: 'Double Time Onsite', main: false, onsite: true },
	{ code: 410, label: 'Double Time Diving', main: false, onsite: true },
	{ code: 411, label: 'Double Time Tending', main: false, onsite: true },
	{
		code: 603,
		label: 'Onsite',
		main: false,
		onsite: true
	},
	{
		code: 610,
		label: 'Diving',
		main: false,
		onsite: true
	},
	{
		code: 611,
		label: 'Tending - Supervisor NY Project EDC',
		main: false,
		onsite: true
	},
	{ code: 633, label: 'Party Chief NYDOT', main: false, onsite: true },
	{ code: 634, label: 'Instrument Person NYDOT', main: false, onsite: true },
	{ code: 635, label: 'Rod Person NYDOT', main: false, onsite: true }
];
